module.exports = __webpack_public_path__ + "static/design-leather.4d741883.svg";